module.exports = __webpack_public_path__ + "img/MainCircle.1792b475.svg";